// extracted by mini-css-extract-plugin
export default {"landing-page-main":"LandingPageTemplates_landing-page-main__6hV2z","item":"LandingPageTemplates_item__JhVNB"};